<template>
  <div class="page_all">
    <div class="return_link"></div>
    <div class="page_header">
      <div class="header_title">
        <div class="title">災害種別</div>
        <div class="area_checkboxs_div">
          <div class="area_checkbox_div">
            <input class="area_checkbox" id="en_check" type="checkbox" v-model="checkNameEi">
            <label class="form-check-label area_check_label" for="en_check">英語</label>
          </div>
          <div class="area_checkbox_div">
            <input class="area_checkbox" id="kan_check" type="checkbox" v-model="checkNameKan" @change="onChangeKan">
            <label class="form-check-label area_check_label" for="kan_check">韓国語</label>
          </div>
          <div class="area_checkbox_div">
            <input class="area_checkbox" id="chu_han_check" type="checkbox" v-model="checkNameChuHan">
            <label class="form-check-label area_check_label" for="chu_han_check">中国語(繁体字)</label>
          </div>
          <div class="area_checkbox_div">
            <input class="area_checkbox" id="chu_kan_check" type="checkbox" v-model="checkNameChuKan">
            <label class="form-check-label area_check_label" for="chu_kan_check">中国語(簡体字)</label>
          </div>
        </div>
        <div class="message">
          <div class="error">{{ message }}</div>
        </div>
      </div>
      <button class="btn_plus" v-on:click="disasterTypeAdd()">＋</button>
    </div>
    <div class="page_main">
      <table class="tbl_main">
        <thead>
          <tr>
            <th class="th_type">種別(日本語)</th>
            <th class="th_description">説明(日本語)</th>
            <th v-if="checkNameEi" class="th_type">種別(英語)</th>
            <th v-if="checkNameEi" class="th_description">説明(英語)</th>
            <th v-if="checkNameKan" class="th_type">種別(韓国語)</th>
            <th v-if="checkNameKan" class="th_description">説明(韓国語)</th>
            <th v-if="checkNameChuHan" class="th_type">種別(中国語:繁体字)</th>
            <th v-if="checkNameChuHan" class="th_description">説明(中国語:繁体字)</th>
            <th v-if="checkNameChuKan" class="th_type">種別(中国語:簡体字)</th>
            <th v-if="checkNameChuKan" class="th_description">説明(中国語:簡体字)</th>
            <th class="th_mark">マーク</th>
            <th class="th_delete"></th>
          </tr>
        </thead>
        <tbody>
            <tr v-for="disaster in disasters" v-bind:key="disaster.id">
              <td class="td_type">
                <router-link v-on:click.native="disasterTypeUpdate(disaster.disaster_id)" to="">{{ disaster.disaster_name }}</router-link>
              </td>
              <td class="td_description">{{ disaster.description }}</td>
              <td v-if="checkNameEi" class="td_type">
                {{ disaster.disaster_name_ei}}
              </td>
              <td v-if="checkNameEi" class="td_description">
                {{ disaster.description_ei}}
              </td>
              <td v-if="checkNameKan" class="td_type">
                {{ disaster.disaster_name_kan}}
              </td>
              <td v-if="checkNameKan" class="td_description">
                {{ disaster.description_kan}}
              </td>
              <td v-if="checkNameChuHan" class="td_type">
                {{ disaster.disaster_name_chu_han}}
              </td>
              <td v-if="checkNameChuHan" class="td_description">
                {{ disaster.description_chu_han}}
              </td>
              <td v-if="checkNameChuKan" class="td_type">
                {{ disaster.disaster_name_chu_kan}}
              </td>
              <td v-if="checkNameChuKan" class="td_description">
                {{ disaster.description_chu_kan}}
              </td>
              <td class="td_mark">
                <div class="mark_outer">
                  <div class="mark_inner" id="color_box" v-bind:style="{backgroundColor: 'rgb(' + disaster.mark_color + ')'}">
                    <a>{{disaster.disaster_name}}</a>
                  </div>
                </div>
              </td>
              <td class="td_delete">
                <button class="btn_delete" v-on:click="disasterTypeDel(disaster.disaster_id)">X</button>
              </td>
            </tr>
        </tbody>
      </table>
    </div>
    <confirm-dialog ref="deleteDialog" primary-label="削除" secondary-label="キャンセル"/>
  </div>
</template>

<script>
import ConfirmDialog from "@/components/ConfirmDialog";
export default {
  components: {
    ConfirmDialog
  },
  data() {
    return {
      disasters: null,
      innerCheckNameEi: sessionStorage.getItem('disasterCheckNameEi') != null ? sessionStorage.getItem('disasterCheckNameEi') === "true" : "",
      checkNameKan: sessionStorage.getItem('disasterCheckNameKan') != null ? sessionStorage.getItem('disasterCheckNameKan') === "true" : "",
      innerCheckNameChuHan: sessionStorage.getItem('disasterCheckNameChuHan') != null ? sessionStorage.getItem('disasterCheckNameChuHan') === "true" : "",
      innerCheckNameChuKan: sessionStorage.getItem('disasterCheckNameChuKan') != null ? sessionStorage.getItem('disasterCheckNameChuKan') === "true" : "",
      // メッセージ
      message: ""
    }
  },
  mounted() {
    this.getDisasterTypeList()
  },
  methods: {
    async getDisasterTypeList() {
      const response = await this.$axios.get(process.env.VUE_APP_API_BASEURL + 'disaster/list', {
        params: {
          municipality_key: this.$store.getters.getStateMunicipalityKey
        }
      })
      this.disasters = response.data
      console.log(this.disasters)
    },
    async disasterTypeDel(disaster_id) {
      const disasterType = this.disasters && this.disasters.find(disasterType => disasterType.disaster_id === disaster_id) || null;
      if (!disasterType) {
        return;
      }
      const result = await this.$refs.deleteDialog.asyncShow(`${disasterType.disaster_name}を削除してよろしいですか？`);
      if (!result) {
        return;
      }
      try {
        await this.$axios.post(process.env.VUE_APP_API_BASEURL + 'disaster/del', {
          disaster_id: disaster_id,
          charge_id: this.$store.getters.getStateChargeId
        })
        this.getDisasterTypeList()
      } catch (err) {
        this.message = err.response.data.errorMessage
      }
    },
    disasterTypeAdd: function() {
      // 変更フラグ
      this.$store.commit('setStateChangeFlg', false)
      this.$router.push({ name: 'disasterTypeDetail' })
    },
    disasterTypeUpdate: function(disaster_id) {
      // 変更フラグ
      this.$store.commit('setStateChangeFlg', true)
      // 災害種別コードをStoreにセット
      this.$store.commit('setStateDisasterId', disaster_id)
      this.$router.push({ name: 'disasterTypeDetail' })
    },
    onChangeKan: function(event) {
      this.checkNameKan = event.target.checked
      sessionStorage.setItem('disasterCheckNameKan', this.checkNameKan)
    }
  },
  computed: {
    checkNameEi: {
      get() {
        return this.innerCheckNameEi
      },
      set(value) {
        this.innerCheckNameEi = value
        sessionStorage.setItem('disasterCheckNameEi', value)
      }
    },
    checkNameChuHan: {
      get() {
        return this.innerCheckNameChuHan
      },
      set(value) {
        this.innerCheckNameChuHan = value
        sessionStorage.setItem('disasterCheckNameChuHan', value)
      }
    },
    checkNameChuKan: {
      get() {
        return this.innerCheckNameChuKan
      },
      set(value) {
        this.innerCheckNameChuKan = value
        sessionStorage.setItem('disasterCheckNameChuKan', value)
      }
    }
  }
}
</script>

<style scoped>
.area_checkboxs_div {
  margin: 0 0 0 20px;
  display: flex;
}
.area_checkbox_div {
  margin: 0 10px 0 0 ;
}
.area_checkbox {
  margin: 0 3px 0 0;
}
.area_check_label {
  font-size: smaller;
}
.page_all {
  width: 1100px;
  margin-top: 20px;
  margin-left: auto;
  margin-right: auto;
}
.page_all_wide {
  width: 1200px;
  margin-top: 20px;
  margin-left: auto;
  margin-right: auto;
}
.tbl_main {
  width: 1100px;
  border: 1px #666666 solid;
  border-collapse: collapse;
}
.tbl_main_wide {
  width: 1200px;
  border: 1px #666666 solid;
  border-collapse: collapse;
}
table th.th_type {
  width: 300px;
}
table th.th_description {
  width: 555px;
}
table th.th_mark {
  width: 200px;
}
table th.th_delete {
  width: 30px;
}

table td {
  word-break: break-all;
}

table td.td_type {
  text-align: left;
  padding-left: 10px;
}
table td.td_description {
   text-align: left;
  padding-left: 10px;
}
table td.td_mark {
  padding: 10px;
}
table td.td_delete {
  text-align: center;
}

.mark_outer {
  display: table;
  margin: 0 auto;
}
.mark_inner {
  background-color: rgb(192,192,192);
  width: 45px;
  height: 45px;
  text-align: center;
  font-size: 12px;
  font-family: Arial;
  display: table-cell;
  vertical-align: middle;
  border-radius: 7px 7px 7px 7px;
  color: #F4F4F4;
}
</style>